import { STATIC_HOST } from "lib/constants";

export const staticURL = (filePath) => `${STATIC_HOST}/${filePath}`;
